import { render, staticRenderFns } from "./InformationIcon.vue?vue&type=template&id=46cecd57&scoped=true"
import script from "./InformationIcon.vue?vue&type=script&lang=js"
export * from "./InformationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cecd57",
  null
  
)

export default component.exports